import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Form, Modal, FormGroup } from "react-bootstrap";

import Button from "../../../../../components/common/button/Button";
import styles from "./AdvancedSearch.scss";
import AddFilterBox from "./AddFilterBox";

import { getFilterFromRouteState } from "../../../../../utils/parseQueries";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false
    };

    this.handleClose = this.handleClose.bind(this);
    this.applyAdvancedSearch = this.applyAdvancedSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleClose() {
    this.setState({ show: false }, this.props.onClose);
  }

  applyAdvancedSearch() {
    this.handleClose();
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <Form onSubmit={this.props.handleSubmit}>
            <FormGroup>
              <div className={styles.title}>Advanced Search</div>
              <div className={styles.dividerDouble} />
              <div className={styles.subtitle}>
                Narrow your search with a keyword.
              </div>
              <div className={styles.filtersContainer}>
                <AddFilterBox
                  name="filters"
                  addText="Add Filter"
                  onClick={this.handleAddFilter}
                />
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                type="submit"
                label="View Results"
                onClick={this.applyAdvancedSearch}
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

Filters = reduxForm({
  form: "usersTableAdvancedSearch",
  enableReinitialize: true,
  destroyOnUnmount: true
})(Filters);

Filters = connect(state => {
  return {
    initialValues: getFilterFromRouteState(state, "advancedSearch")
  };
})(Filters);

export default Filters;



// WEBPACK FOOTER //
// ./src/routes/admin/users/components/advancedSearch/Filters.js